import type { SelectProjectsResponse } from 'hooks/api/general/useGetSelectProjects';

import type { GenericDetails } from 'components/Input/Autocomplete';

import type { Field, FormDataType } from './types';

export const generateValues = (newItem?: GenericDetails): GenericDetails => {
    return {
        id: newItem?.id ?? '',
        name: newItem?.name ?? '',
        value: newItem?.value ?? '',
    };
};

export const checkEmptyValues = (data?: FormDataType) => {
    let status = false;

    if (!data) return status;

    Object.values(data).forEach((value) => {
        if ((value.id !== '' || value.value !== '') && value.name !== '') {
            status = true;
        }
    });

    return status;
};

export interface NormalizedOption {
    name: string;
    id: string | number;
    value: string | number;
}

// Type guard to check if an object is a SelectProjectsResponse
function isSelectProjectsResponse(option: unknown): option is SelectProjectsResponse {
    if (typeof option !== 'object' || option === null) {
        return false;
    }

    return false;
}

export const normalizeFieldOptions = (
    options: Field['options'],
    defaultOptionName: string,
    defaultOptionId: string,
    defaultOptionValue: string
): NormalizedOption[] => {
    if (!options) return [];

    return options.map((option) => {
        if (typeof option === 'string') {
            return {
                name: option,
                id: option,
                value: option,
            };
        }

        if (isSelectProjectsResponse(option)) {
            return {
                name: option.name,
                id: option.id,
                value: option.id,
            };
        }

        return {
            name: option[defaultOptionName],
            id: option[defaultOptionId],
            value: option[defaultOptionValue],
        };
    });
};
